import React from "react";
import Tickets from "./Tickets";

const DriverTickets = () => {
  return <Tickets />;
};

export default DriverTickets;
